"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetURLParams = void 0;
function GetURLParams(paramName, type) {
    const urlParams = new URLSearchParams(window.location.search);
    const param = urlParams.get(paramName);
    if (!param) {
        return undefined;
    }
    if (type === "string") {
        return param;
    }
    if (type === "number") {
        const paramInt = parseInt(param);
        if (Number.isInteger(paramInt)) {
            return paramInt;
        }
    }
    if (type === "boolean") {
        if (param === "true") {
            return true;
        }
        else if (param === "false") {
            return false;
        }
    }
    return undefined;
}
exports.GetURLParams = GetURLParams;
//# sourceMappingURL=GetURLParam.js.map